import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=588bfd18&scoped=true&"
var script = {}
import style0 from "./LoginLayout.vue?vue&type=style&index=0&id=588bfd18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588bfd18",
  null
  
)

export default component.exports